export default __webpack_public_path__ + "static/media/ambie.64a766af.png";